import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { CarePlan } from "@/models/CarePlanModel.ts";
import { TeleMonitoringCriteria, telemonitoringCriteriaTranslationMap } from "@/models/TelemonitoringCriteriaModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type TelemonitoringCriteriaColumnProps = CellContext<CarePlan, TeleMonitoringCriteria>;

export const TelemonitoringCriteriaColumn: React.FC<TelemonitoringCriteriaColumnProps> = ({ getValue }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Typography className={styles.text} variant="body">
        {t(telemonitoringCriteriaTranslationMap[getValue()])}
      </Typography>
    </div>
  );
};

const makeStyles = () => ({
  container: css({
    display: "flex",
  }),
  text: css({
    minWidth: 0,
    textOverflow: "ellipsis",
    overflow: "clip",
  }),
});
